import { UsaStates } from '../constants/enums';
import { usePaymentState } from '../components/Checkout/hooks/use-payment-state';
import { useCheckout } from './use-checkout';
import { useAppConfig } from './use-app-config';
import { countriesExcludedFromDefaultSaveCardBox } from '../constants/excludedCountries';

export function useAllowDefaultCheckSavedCardBox(): {
  isDefaultSaveCardAllowedForLocation: boolean;
} {
  const customerGeoState = usePaymentState((state) => state.customerGeoState);
  const { checkoutData } = useCheckout();
  const { featureFlags } = useAppConfig();
  const countryCode2 = (
    checkoutData?.customer.taxCountry ||
    checkoutData?.customer.geoLocator.countryCode2 ||
    ''
  ).toUpperCase();

  const state =
    customerGeoState ||
    checkoutData?.customer.address?.state ||
    checkoutData?.customer.geoLocator.state;

  const isCalifornia = state?.toLowerCase() === UsaStates.CALIFORNIA;

  const isDefaultSaveCardAllowedForLocation =
    !countriesExcludedFromDefaultSaveCardBox.has(countryCode2) && !isCalifornia;

  const isFeatureEnabled = Boolean(featureFlags?.checkout_select_save_card_by_default);

  return {
    isDefaultSaveCardAllowedForLocation: isFeatureEnabled && isDefaultSaveCardAllowedForLocation,
  };
}
